import React from 'react';
import PropTypes from 'prop-types';
import { Pill } from 'day8-ui';

import { FaCircleInfo } from "@react-icons/all-files/fa6/FaCircleInfo";
import { LuFuel } from '@react-icons/all-files/lu/LuFuel';
import DiscountPill from '../booking-options/DiscountPill';
import UrgencyPill from '../booking/UrgencyPill';
import { useLocation } from 'react-router-dom';
import { useAutomaticDiscounts } from '../../context/AutomaticDiscountsContext';
import { getPromoBookingSubjectFromLocation } from '../../helpers/promoCode';
import { BOOKING } from '../../constants';

const SidebarPills = ({
  className, week, flexible, hideDiscountPill, isCabin, deadline, urgencyPillLimit, freeFuel, packageId, isNonStandard = false
}) => {
  const location = useLocation();
  const { getDiscountForWeekAndSubject } = useAutomaticDiscounts();
  const subject = isCabin ? getPromoBookingSubjectFromLocation(location) : BOOKING.YACHT_SUBJECT;
  const discount = getDiscountForWeekAndSubject(week?.id, subject, packageId, !isCabin && isNonStandard);
  const discountAmount = discount?.discountPercentage || 0;
  const hidePayLater = deadline && deadline?.postBookingDays > 0 ? false : true;
  if (discountAmount > 0 && !hideDiscountPill) {
    return (
      <div className={`dui-flex dui-flex-wrap dui-items-start dui-gap-4`}>
        <DiscountPill className={`dui-text-sm ${className}`} weekId={week.id} hidden={hideDiscountPill} isCabin={isCabin} packageId={packageId} isNonStandard={isNonStandard} />
      </div>
    );
  }
  return (
    <div className={`dui-flex dui-flex-wrap dui-items-start dui-gap-4`}>
      {urgencyPillLimit != null && <UrgencyPill className={`dui-text-sm ${className}`} limit={urgencyPillLimit} />}
      {!hidePayLater && <Pill className={`dui-text-sm ${className}`} type="SECONDARY">€100 deposit to reserve</Pill>}
      {freeFuel && <Pill className={`dui-text-sm ${className}`} leftIcon={<LuFuel />}>Free fuel</Pill>}
      {flexible && (
        <a className={className} href="https://www.theyachtweek.com/flexible-booking" target="_blank" rel="noopener noreferrer">
          <Pill className={`dui-cursor-pointer dui-text-sm`} leftIcon={<FaCircleInfo />}>Flexible</Pill>
        </a>
      )}
    </div>
  );
};

SidebarPills.propTypes = {
  flexible: PropTypes.bool,
  week: PropTypes.object,
  className: PropTypes.string,
  hideDiscountPill: PropTypes.bool,
  isCabin: PropTypes.bool,
  packageId: PropTypes.number,
  isNonStandard: PropTypes.bool
};

export default SidebarPills;
